// 声明常量type


//左侧导航
export const SWITCH_LEFT_NAV = 'SWITCH_LEFT_NAV';




// WEBPACK FOOTER //
// ./src/store/actionType/index.js